// * DOCUPLOAD STORE MODULE
const docUpload_store = {
    namespaced: true,
    // * STATE
    state: {
        docUploadResult: null,
    },
    // * MUTATIONS
    mutations: {
        MUT_docUpload(state, data) { state.docUpload = data },
        MUT_docUploadResult(state, data) { state.docUploadResult = data },
    },
    // * GETTERS
    getters: {
        GET_docUpload(state) { return state.docUpload },
        GET_docUploadResult(state) { return state.docUploadResult },
    },
    // * ACTIONS
    actions: {
        ACT_docUpload({commit}, payload){ commit('MUT_docUpload', payload) },
        ACT_docUploadResult({commit}, payload){ commit('MUT_docUploadResult', payload) },
    }    

};
export default docUpload_store;
